import {Observable} from 'rxjs';
import {palipaliAPI} from '../provider/palipaliAPI';
import {IApiSingleResponseBase, ICanOutput} from '../../types';
import {RestQueryParams} from '../base/queryParams';

export function getCanUnassignCourierAPI(authToken: string, id: string): Observable<IApiSingleResponseBase<ICanOutput>> {
    return palipaliAPI.get(`api/fleet_partner_couriers/${id}/can_unassign`, new RestQueryParams(), {
        Authorization: `Bearer ${authToken}`,
    });
}
